import { GetUserJwt, reqGetUserJwt } from '@weblite/ts-action/auth'
import { contentJwtStorage, userJwtStorage } from '$logic/auth/storage'
import { request } from '$setup/ws'
import { isExpiredJwt } from '$func/jwt'

export async function getClientUserIdentityToken() {
  const cachedToken = userJwtStorage.get()?.token
  if (cachedToken && !isExpiredJwt(cachedToken)) return cachedToken

  const res = await request<GetUserJwt>(reqGetUserJwt({}), { retry: -1 })
  if (res.error) return null

  userJwtStorage.set({ token: res.payload.jwt })
  return res.payload.jwt
}

export async function getClientUserContentToken(contentUri: string) {
  const tokens = contentJwtStorage.get()
  const cachedToken = tokens?.[contentUri]

  if (cachedToken && !isExpiredJwt(cachedToken)) return cachedToken

  const res = await request<GetUserJwt>(reqGetUserJwt({ contentUri }))
  if (res.error) return null

  contentJwtStorage.set({ ...tokens, [contentUri]: res.payload.jwt })
  return res.payload.jwt
}
